// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"NotFoundPage_Wrapper__ZFXqo","StatusCode":"NotFoundPage_StatusCode__eOU5Y"};